module.exports = __webpack_public_path__ + "img/paystack-logo-vector.eaab73c4.svg";